// ../rounds/RoundAccordion.jsx
import { useMemo, useState, useEffect } from "react";
import { peDate, peTime } from "../../util/util";

// formatea "2025-10-10T13:45:00Z" -> "13:45"
function hhmm(ts) {
  if (!ts) return "–";
  let s = String(ts);
  s = s.replace(/(\.\d{3})\d+/, "$1"); // recorta ".sssssss" -> ".sss"
  const d = new Date(s);
  if (isNaN(d)) return "–";
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

function mmss(totalSeconds) {
  const s = Math.max(0, Math.floor(totalSeconds || 0));
  const m = Math.floor(s / 60);
  const ss = s % 60;
  return `${String(m).padStart(2, "0")}:${String(ss).padStart(2, "0")}`;
}
/**
 * props:
 *  - roundsInfo:  { rid: { id, user: { name }, ... } }
 *  - roundPoints: { rid: { items:[{ order, pointControlId, derivedState, initDate, endDate, ... }], visitedCount?, ... } }
 *  - pcNameById:  { pointControlId: "Nombre" }
 *  - openId, setOpenId: control del colapso
 */
export default function RoundAccordion({ roundsInfo, roundPoints, openId, setOpenId, pcNameById, roundStateById, userNameById, offlineAfterMs, removeAfterMs, pcAll }) {

  const rows = useMemo(() => Object.keys(roundPoints || {}), [roundPoints]);
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <section style={{ padding: 12 }}>

      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {rows.map((rid) => {
          const info = roundsInfo?.[rid] || {};
          // const status = roundPoints?.[rid] || {};
          // const statusItems = Array.isArray(status.items) ? status.items : [];
          // const statusById = Object.fromEntries(statusItems.map(it => [it.pointControlId, it]));
          const rawStatus = roundPoints?.[rid] || [];
          const statusItems = Array.isArray(rawStatus?.items) ? rawStatus.items
            : (Array.isArray(rawStatus) ? rawStatus : []);
          const statusById = Object.fromEntries(statusItems.map(it => [it.pointControlId, it]))


          // 3) fusión: TODOS los PCs del patio + horas del status cuando existan
          const items = (pcAll || []).map((pc, idx) => {
            const it = statusById[pc.id] || {};
            return {
              order: pc.order ?? idx + 1,
              pointControlId: pc.id,
              pointName: pc.name,
              derivedState: it.derivedState ?? 0,
              initDate: it.initDate ?? it.enterDate ?? it.arrivedAt ?? it.startDate ?? it.checkinDate ?? it.initDatePlanning,
              endDate: it.endDate ?? it.exitDate ?? it.leftAt ?? it.finishDate ?? it.checkoutDate ?? it.endDatePlanning
            };
          });

          const total = items.length;
          const visited = typeof status.visitedCount === "number"
            ? status.visitedCount
            : items.filter(it => (it.derivedState ?? 0) > 0).length;

          const isOpen = openId === rid;

          // 4) encabezado: puntito + nombre + cronómetro (solo offline)
          const st = roundStateById?.[rid] || {};
          const color = st.status === "online" ? "#16a34a" : "#f59e0b";
          const lastSeen = st.lastSeenTs ?? 0;
          const offlineFor = now - lastSeen - (offlineAfterMs || 0);

          const secsToRemove = Math.max(
            0,
            Math.floor(((removeAfterMs || 0) + (offlineAfterMs || 0) - (now - lastSeen)) / 1000)
          );

          const userLabel =
            info?.user?.name ||
            info?.user?.lastName ||
            userNameById?.[rid] ||
            "Vigilante";

          return (
            <div key={rid} style={{ border: "1px solid #e5e7eb", borderRadius: 8, overflow: "hidden" }}>
              {console.log("acordion info")}
              {console.log(info)}

              <button
                onClick={() => setOpenId(isOpen ? null : rid)}
                style={{
                  width: "100%", textAlign: "left", background: "#fff", border: 0, padding: "10px 12px",
                  display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer"
                }}
              >
                {/* IZQUIERDA: puntito + nombre */}
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <span style={{ width: 10, height: 10, borderRadius: "50%", background: color }} />
                  <strong>{userLabel || "Vigilante"} {info.user.lastName || ""}</strong>
                </div>

                {/* DERECHA: progreso (opcional) + cronómetro SOLO si está offline + flecha */}
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  {/* <small style={{ background:"#eef2ff", color:"#3730a3", borderRadius:999, padding:"2px 6px" }}>{visited}/{total}</small> */}

                  {st.status !== "online" && offlineFor >= 0 && (
                    <small style={{
                      background: "#fff7ed", color: "#c2410c", border: "1px solid #fed7aa",
                      borderRadius: 6, padding: "2px 6px", fontVariantNumeric: "tabular-nums"
                    }}>
                      {mmss(secsToRemove)}
                    </small>
                  )}

                  <span style={{ color: "#6b7280" }}>{isOpen ? "▾" : "▸"}</span>
                </div>
              </button>

              {/* contenido */}
              {isOpen && (
                <div style={{ background: "#fff", padding: 12, borderTop: "1px solid #e5e7eb" }}>
                  <div className="mb-3"> <strong>Hora:</strong> {peTime(info.initDatePlanning)} - {peTime(info.endDatePlanning)}</div>
                  <table className="table table-sm" style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th style={th}>#</th>
                        <th style={th}>Puntos</th>
                        <th style={th}>Hora</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((it) => {
                        const name = pcNameById?.[it.pointControlId] || it.pointName || "—";
                        const start = it.initDate;
                        const end = it.endDate;
                        return (
                          <tr key={it.pointControlId ?? it.order} style={{ borderTop: "1px solid #f3f4f6" }}>
                            <td style={td}>{it.order}</td>
                            <td style={td}>{name}</td>
                            <td style={td}>{hhmm(start)} &nbsp;–&nbsp; {hhmm(end)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}

const th = { textAlign: "left", fontWeight: 600, padding: "6px 8px", borderBottom: "1px solid #f3f4f6" };
const td = { padding: "6px 8px", verticalAlign: "top" };
